import { generateMetaTags } from 'helpers';
import LegalPages from 'Layout/LegalPages';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectPrivacyPolicy,
    selectPrivacyPolicyIsLoading,
    fetchPrivacyPolicy,
    selectPrivacyPolicyTags,
} from 'store/slices/LegalSlice';

const PrivacyPolicy = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectPrivacyPolicyIsLoading);
    const data = useSelector(selectPrivacyPolicy);

    const privacyPolicyTags = useSelector(selectPrivacyPolicyTags);
    const metaTags = generateMetaTags(privacyPolicyTags?.tags, 'meta');

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchPrivacyPolicy());
    }, [dispatch]);

    const { blocks, title, updatedAt } = data;

    return <LegalPages loading={isLoading} title={title} blocks={blocks} updatedAt={updatedAt} metaTags={metaTags} />;
};

export default PrivacyPolicy;
